// Modules
import cn from 'classnames';

// Types
import type { TChipProps } from './Chip.type';

// Styles
import styles from './styles/styles.module.scss';

// Constants
import { CHIP_DEFAULT_PROPS } from './Chip.constant';

const Chip = (props: TChipProps) => {
	const {
		children,
		className,
		color = CHIP_DEFAULT_PROPS.color,
		hoverable,
		size = CHIP_DEFAULT_PROPS.size,
		variant = CHIP_DEFAULT_PROPS.variant,
		...restProps
	} = props;

	const chipCN = cn(styles.legion_chip, className, styles[color!], styles[size!], styles[variant!], {
		[styles.hoverable]: hoverable
	});

	return (
		<div className={chipCN} {...restProps}>
			{children}
		</div>
	)
}

export default Chip
